/// <amd-module name="Dashboards/Directory/components/OwnerCell" />
import * as React from "react";
import { IDirectoryRow } from "VSS/Features/Directory/DirectoryGrid";
import { Tooltip } from "VSSUI/TooltipEx";
import { IVssPersonaProps, VssPersona } from "VSSUI/VssPersona";
import { IDashboardsDirectoryArtifact } from "../DashboardsDirectoryContracts";

export interface IOwnerCellProps<T extends IDashboardsDirectoryArtifact> {
    row: IDirectoryRow<T>;
    isOwner: boolean;
    dateString: string|undefined;
}

/** 
 * Legacy code - will be removed once new Dashboard directory is moved to GA
 * Renders the owner of a dashboard */
export class OwnerCell<T extends IDashboardsDirectoryArtifact> extends React.PureComponent<IOwnerCellProps<T>> {
    public render(): JSX.Element {
        const {
            row: { data }
        } = this.props;

        if (!data || !data.owners || data.owners.length === 0) {
            return <></>;
        }

        const ownerName = (this.props.isOwner)? data.ownerName:data.modifiedByName;
        const ownerImageUrl = (this.props.isOwner)? data.ownerImageUrl:data.modifiedByImageUrl;

        const personaProps: IVssPersonaProps = {
            displayName: ownerName,
            imageUrl: ownerImageUrl,
            className: "dashboard-owner-persona",
            size: "extra-small-plus"
        }

        return (
            <div className="dashboards-directory-row-owner-cell">
                <VssPersona {...personaProps} />
                <Tooltip overflowOnly={true} text={ownerName}>
                    <span className="owner-name flex-tooltip-host">{ownerName}</span>
                </Tooltip>
                {(this.props.dateString) ? <span>&nbsp;updated&nbsp;{this.props.dateString}</span>:''}
            </div>
        );
    }
}
